<div id="searchModal" tabindex="-1" role="dialog" aria-labelledby="globalSearchLabel" aria-hidden="false"
    class="modal search-modal fade">
    <div class="modal-dialog" style="max-width: 100% !important;">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" data-dismiss="modal" [attr.aria-label]="bs.getResource('rbkey_ClsLBL')"
                    class="close" (click)="closeSearchDetail()" style="padding-right: 5%;">
                    <span aria-hidden="true"></span>
                </button>
                <div class="modal-container">
                    <div class="row">
                        <div class="col-md-7 col-xs-11">
                            <div class="input-group m-b">
                                <input autofocus type="text" class="form-control" id="searchInputControl" #search
                                    (keyup.enter)="globalSearchClick(true)">
                                <a href="javascript:void(0);" (click)="globalSearchClick(true)"style="margin-top: 1%;margin-left: 1%;">
                                    <i class="fa fa-search"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-body">

                <div id="globalsearchsection" class="ad-search-slider">
                    <div class="modal-container">
                        <div class="col-md-8">
                            <div style="width: 800px !important" class="owl-carousel owl-theme owl-carousel-global-search" id="advance-search-menus">

                                <div class="item" *ngIf= "bs.HasVariantAccess(bs.BaseVariantType)">
                                    <div id="LA" class="tablinks2" (click)="openTab($event, 'L')">
                                        {{bs.getResource('rbkey_LrnngLBL')}}
                                    </div>
                                </div>
                                <div class="item" *ngIf= "bs.HasVariantAccess(bs.GrowVariantType)">
                                    <div id="DA" class="tablinks2" (click)="openTab($event, 'D')">
                                        {{bs.getResource('rbkey_CnvrstnLBL')}}
                                    </div>
                                </div>
                                <div class="item" *ngIf= "bs.HasVariantAccess(bs.GrowVariantType)">
                                    <div id="SA" class="tablinks2" (click)="openTab($event, 'S')">
                                        {{bs.getResource('rbkey_SrvyLBL')}}
                                    </div>
                                </div>
                                <div class="item" *ngIf= "bs.HasVariantAccess(bs.GrowVariantType)">
                                    <div id="VA" class="tablinks2" (click)="openTab($event, 'V')">
                                        {{bs.getResource('rbkey_VdsLBL')}}
                                    </div>
                                </div>
                                <div class="item" *ngIf= "bs.HasVariantAccess(bs.LearnVariantType)">
                                    <div id="BA" class="tablinks2" (click)="openTab($event, 'B')">
                                        {{bs.getResource('rbkey_BrfCsLBL')}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-container">
                    <div class="row">
                        <div class="ad-search-text" id="globalSearchLabel">
                            <div class="modal-container">{{searchListData['TotalResults']}}
                                {{bs.getResource('rbkey_SrchResultLBL')}}

                            </div>
                        </div>

                        <app-search-card [searchCardDataList]="searchCardDataList" (openEvent)="routeItem($event)">
                        </app-search-card>

                        <div style="padding: 15px 10px 15px 5px!important;"></div>
                        <div id="globalShowMoreDiv" style="display:none;">
                            <button class="btn btn-primary"
                                (click)="showMore()">{{bs.getResource('rbkey_ShwMrLBL')}}<span
                                    class="arrow_down"></span>

                            </button>
                        </div>
                        <div style="padding: 5px 10px 55px 5px!important;"></div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>